import AdminType from '../Interfaces/admin-interface';

export type objects =
  | 'Home'
  | 'Setting'
  | 'Wallet'
  | 'Address'
  | 'Layout'
  | 'Device'
  | 'ScrapingOrder'
  | 'OrderNote'
  | 'Deposit'
  | 'ScrapingCart'
  | 'Advertisement'
  | 'User'
  | 'MainSectionCategory'
  | 'Group'
  | 'MainSection'
  | 'ScrapingItem'
  | 'Product'
  | 'Outfit'
  | 'Transaction'
  | 'DriverTransactions'
  | 'Report'
  | 'Offer'
  | 'PaymentMethod'
  | 'PaymentMethodDiscount'
  | 'Notification'
  | 'PromoCode'
  | 'CartOffer'
  | 'CartGift'
  | 'Discount'
  | 'SocialLink'
  | 'Driver'
  | 'Admin'
  | 'Team'
  | 'Refund'
  | 'RefundRequest'
  | 'Warehouse'
  | 'Shipment'
  | 'Category'
  | 'Message'
  | 'Automation'
  | 'Province'
  | 'City'
  | 'DriverAreaAssignment'
  | 'TryOnAi'
  | 'all';

export enum objectsEnum {
  'Home',
  'Setting',
  'Wallet',
  'Address',
  'Layout',
  'Device',
  'ScrapingOrder',
  'OrderNote',
  'Deposit',
  'ScrapingCart',
  'Advertisement',
  'User',
  'MainSectionCategory',
  'Group',
  'MainSection',
  'ScrapingItem',
  'Product',
  'Outfit',
  'Transaction',
  'Report',
  'Offers',
  'PaymentMethod',
  'PaymentMethodDiscount',
  'Notification',
  'PromoCode',
  'CartOffer',
  'Discount',
  'SocialLink',
  'Driver',
  'Admin',
  'Team',
  'Refund',
  'RefundRequest',
  'Warehouse',
  'Shipment',
  'Category',
  'Message',
  'Automation',
  'all',
}

export enum abilitiesEnum {
  'Read',
  'Create',
  'Update',
  'Delete',
}

export const initialAbilities = ['read', 'create', 'update', 'delete'];

export const permissionsList = [
  { label: 'Home', value: 'Home' },
  { label: 'Scraping Orders', value: 'ScrapingOrder' },
  { label: 'Order Notes', value: 'OrderNote' },
  { label: 'Order Delivery Notes', value: 'Deposit' },
  { label: 'Scraping Cart', value: 'ScrapingCart' },
  { label: 'Advertisements', value: 'Advertisement' },
  { label: 'Customers', value: 'User' },
  { label: 'Main Section Categories', value: 'MainSectionCategory' },
  { label: 'Groups', value: 'Group' },
  { label: 'Main Sections', value: 'MainSection' },
  { label: 'Scraping Item', value: 'ScrapingItem' },
  { label: 'Product', value: 'Product' },
  { label: 'Layout', value: 'Layout' },
  { label: 'Outfit', value: 'Outfit' },
  { label: 'Transactions', value: 'Transaction' },
  { label: 'Reports', value: 'Report' },
  { label: 'Payment Methods', value: 'PaymentMethod' },
  { label: 'Payment Method Discounts', value: 'PaymentMethodDiscount' },
  { label: 'Promo Codes', value: 'PromoCode' },
  { label: 'Cart Offers', value: 'CartOffer' },
  { label: 'Cart Gifts', value: 'CartGift' },
  { label: 'Discounts', value: 'Discount' },
  { label: 'Notifications', value: 'Notification' },
  // Watcher
  { label: 'Watcher Messages', value: 'Message' },
  { label: 'Watcher Automations', value: 'Automation' },
  { label: 'Social Links', value: 'SocialLink' },
  { label: 'Drivers', value: 'Driver' },
  { label: 'Admins', value: 'Admin' },
  { label: 'Team', value: 'Team' },
  { label: 'Warehouses', value: 'Warehouse' },
  { label: 'Shipments', value: 'Shipment' },
  { label: 'Categories', value: 'Category' },
  { label: 'Refunds', value: 'Refund' },
  { label: 'Provinces', value: 'Province' },
  { label: 'Cities', value: 'City' },
  { label: 'Areas', value: 'DriverAreaAssignment' },
  { label: 'TRYON', value: 'TryOnAi' },
  // {label: "Driver Transactions", value: "DriverTransactions"},
  { label: 'Wallets', value: 'Wallet' },
  // {label: "Addresses", value: "Address"},
  // {label: "Settings", value: "Setting"},
];

export const initialPermission = {
  object: permissionsList[0].value,
  abilities: ['read'],
};

export type initialPermissiontype = typeof initialPermission;

export const initialErrors = {
  firstName: String() || null,
  lastName: String() || null,
  phoneNumber: String() || null,
  email: String() || null,
  password: String() || null,
  permissions: String() || null,
};

export const initialAdmin = {
  firstName: String(),
  lastName: String(),
  phoneNumber: String(),
  email: String(),
  password: String(),
  permissions: [initialPermission] || null,
};

export type initialAdminType = typeof initialAdmin;
export type initialErrorsType = typeof initialErrors;
export type initialPermissionsType = (typeof initialPermission)[];

export const adminsTableHead = [
  {
    id: 'name',
    numeric: true,
    label: 'Name',
  },
  {
    id: 'phoneNumber',
    numeric: true,
    label: 'Phone Number',
  },
  {
    id: 'location',
    numeric: true,
    label: 'Location',
  },
  {
    id: 'state',
    numeric: true,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: true,
    label: 'CreatedAt',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];
